import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../../StateContext/Application'
import { apiurl } from '../../../../../path'
import { useLanguage } from '../../../../../lang/langcontext/LanguageContext'
import GooglePagination from '../../../styles/GooglePagination'
const BudgetHeadList = () => {
    const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetAllBudgetHeadList } = context
    const [head, setHeadList] = useState([])
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedHeadName, setSelectedHeadName] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;

  const sortedBills = Array.isArray(filteredBills)? filteredBills.slice() // ✅ prevent state mutation
.sort((a, b) => new Date(b.Date) - new Date(a.Date))
        : [];
    const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);

    // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const getBudgetHeadList = async () => {
        let data = await GetAllBudgetHeadList()
        console.log("data", data);

        setHeadList(data)
        setFilteredBills(data);
    }
    useEffect(() => {
        getBudgetHeadList()
    }, [])
    let HeadList = []
    if (head.length > 0) {
        HeadList = head
    }
    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = head.filter(bill =>
            (selectedHeadName === '' || bill.HeadName === selectedHeadName) &&
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1);
    }, [searchTerm, selectedHeadName, head]);
    const uniqueHeadNames = [...new Set(head.map(h => h.HeadName))];

    // return (

    //     <>

    //         <div className="col-12 pb-5" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
    //             <div className="col-11 m-auto">
    //                 <div className="col-12">

    //                     <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

    //                         <h5 className='my-auto fw-bold'>
    //                             <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
    //                             <span className='my-auto'>Head List</span>
    //                         </h5>

    //                         <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
    //                             <img
    //                                 src="/Search32.png"
    //                                 alt="Search Icon"
    //                                 style={{
    //                                     position: "absolute",
    //                                     top: "50%",
    //                                     left: "10px",
    //                                     transform: "translateY(-50%)",
    //                                     width: "16px",
    //                                     height: "16px",
    //                                     opacity: 0.6
    //                                 }}
    //                             />
    //                             <input
    //                                 type="text"
    //                                 placeholder="Search Here"
    //                                 onChange={(e) => setSearchTerm(e.target.value)}
    //                                 value={searchTerm}
    //                                 style={{
    //                                     width: "100%",
    //                                     padding: "8px 12px 8px 32px", // left padding makes space for icon
    //                                     border: "1px solid #ccc",
    //                                     borderRadius: "8px",
    //                                     backgroundColor: "#f1f6fc",
    //                                     fontSize: "14px",
    //                                     color: "#333",
    //                                     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    //                                     outline: "none"
    //                                 }}
    //                             />
    //                         </div>
    //                     </div>

    //                     <div className="col-12 mb-3" style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px" }}>
    //                         <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
    //                             <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
    //                                 <thead>
    //                                     <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
    //                                         <th style={{ width: "4%" }}>Sr.no.</th>
    //                                         <th style={{ width: '10%' }}>Head ID</th>
    //                                         <th style={{ width: '25%' }}>Head Name</th>
    //                                         <th style={{ width: '25%' }}>Head Details</th>
    //                                         {/* <th style={{ width: '20%' }}>Head Amount</th> */}
    //                                         <th style={{ width: '20%' }}>Creation Date</th>
    //                                     </tr>
    //                                 </thead>
    //                                 <tbody>
    //                                     {currentBills?.length === 0 ? (
    //                                         <tr>
    //                                             <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
    //                                                 No data available
    //                                             </td>
    //                                         </tr>
    //                                     ) : (
    //                                         currentBills?.map((head, index) => {
    //                                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
    //                                             return (
    //                                                 <tr style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "500" }} key={index}>
    //                                                     <td style={{ padding: '8px 8px' }}>{(currentPage - 1) * billsPerPage + index + 1}</td>
    //                                                     <td style={{ padding: '8px' }}>{head.HeadID}</td>
    //                                                     <td style={{ padding: '8px' }}>{head.HeadName}</td>
    //                                                     <td style={{ padding: '8px' }}>{head.HeadDetails}</td>
    //                                                     {/* <td style={{ padding: '8px' }}>{head.CRC}</td> */}
    //                                                     <td style={{ padding: '8px' }}>{new Date(head.Date).toLocaleString()}</td>
    //                                                 </tr>
    //                                             );
    //                                         })
    //                                     )}
    //                                 </tbody>
    //                             </table>
    //                         </div>
    //                     </div>

    //                     <div className='col-12'>
    //                         <div className="row">
    //                             <div className='col-6'>
    //                                 <p className="text-gray-600" style={{ fontSize: "14px" }}>
    //                                     Showing {indexOfFirstBill + 1} to {Math.min(indexOfLastBill, filteredBills.length)} of {HeadList.length} entries
    //                                 </p>
    //                             </div>
    //                             <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
    //                                 {/* First Page Button */}
    //                                 <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
    //                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
    //                                     &laquo;
    //                                 </button>
    //                                 {/* Previous Button */}
    //                                 <button
    //                                     onClick={() => setCurrentPage(currentPage - 1)}
    //                                     disabled={currentPage === 1}
    //                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                     &lt;
    //                                 </button>

    //                                 <button
    //                                     style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
    //                                 </button>
    //                                 {/* Next Button */}
    //                                 <button
    //                                     onClick={() => setCurrentPage(currentPage + 1)}
    //                                     disabled={currentPage === totalPages}
    //                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                     &gt;
    //                                 </button>
    //                                 {/* Last Page Button */}
    //                                 <button
    //                                     onClick={() => setCurrentPage(totalPages)}
    //                                     disabled={currentPage === totalPages}
    //                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                     &raquo;
    //                                 </button>
    //                             </div>

    //                         </div>

    //                     </div>

    //                 </div>

    //             </div>

    //         </div>

    //     </>
    // )
     return (

        <>

            <div className="col-12 pb-5" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                    <div className="col-12">

                        <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                            <h5 className='my-auto fw-bold'>
                                <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                                <span className='my-auto'>{t("Budget Head Report")}</span>
                            </h5>

                            <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                                <img
                                    src="/Search32.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "10px",
                                        transform: "translateY(-50%)",
                                        width: "16px",
                                        height: "16px",
                                        opacity: 0.6
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder={t("Search Here")}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    value={searchTerm}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px 8px 32px", // left padding makes space for icon
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                        backgroundColor: "#f1f6fc",
                                        fontSize: "14px",
                                        color: "#333",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                        outline: "none"
                                    }}
                                />
                            </div>
                        </div>

                        <div className="col-12 mb-3" style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px" }}>
                            <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
                                <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                            <th style={{ width: "4%" }}>{t("Sr.no.")}</th>
                                            <th style={{ width: '10%' }}>{t("Head ID")}</th>
                                            <th style={{ width: '25%' }}>{t("Head Name")}</th>
                                            <th style={{ width: '25%' }}>{t("Head Details")}</th>
                                            {/* <th style={{ width: '20%' }}>Head Amount</th> */}
                                            <th style={{ width: '20%' }}>{t("Creation Date")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentBills?.length === 0 ? (
                                            <tr>
                                                <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                    {t("No data available")}
                                                </td>
                                            </tr>
                                        ) : (
                                            currentBills?.map((head, index) => {
                                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                return (
                                                    <tr style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "500" }} key={index}>
                                                        <td style={{ padding: '8px 8px' }}>{(currentPage - 1) * billsPerPage + index + 1}</td>
                                                        <td style={{ padding: '8px' }}>{head.HeadID}</td>
                                                        <td style={{ padding: '8px' }}>{head.HeadName}</td>
                                                        <td style={{ padding: '8px' }}>{head.HeadDetails}</td>
                                                        {/* <td style={{ padding: '8px' }}>{head.CRC}</td> */}
                                                        <td style={{ padding: '8px' }}>{new Date(head.Date).toLocaleString()}</td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className='col-12'>
                            <div className="row">
                                <div className='col-6'>
                                    <p className="text-gray-600" style={{ fontSize: "14px" }}>
                                        {t("Showing")} {indexOfFirstBill + 1} {t("to")} {Math.min(indexOfLastBill, filteredBills.length)} {t("of")} {HeadList.length} {t("entries")}
                                    </p>
                                </div>
                                <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                                    <GooglePagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onPageChange={setCurrentPage}
                                    />
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </>
    )
}

export default BudgetHeadList
